import content from '../../content/homepage';
import { GhostButton } from '../../components/GhostButton';

export function AttckCredibility() {
  const { attckCredibility } = content;

  return (
    <section
      id="attck"
      aria-labelledby="attck-heading"
      className="mx-auto max-w-3xl px-6 py-[var(--spacing-section-lg)] text-center md:px-12 md:py-[var(--spacing-section-xl)]"
    >
      <h2
        id="attck-heading"
        className="font-display text-5xl leading-tight font-medium md:text-6xl lg:text-7xl"
      >
        {attckCredibility.sectionHeading}
      </h2>

      <div className="mx-auto mt-10 max-w-2xl space-y-5 md:mt-12">
        {attckCredibility.paragraphs.map((paragraph, index) => (
          <p
            key={index}
            className="font-body text-lg leading-relaxed text-[color:var(--color-foreground)]/85 md:text-xl"
          >
            {paragraph}
          </p>
        ))}
      </div>

      <div className="mt-12 md:mt-14">
        <GhostButton href={attckCredibility.link.href} external>
          {attckCredibility.link.label}
        </GhostButton>
      </div>
    </section>
  );
}
